module.exports = __webpack_public_path__ + "img/blank-content.12e63893.png";